<script>
export default {
	name: 'IconSvgTiff',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_12_430)">
				<path
					d="M13.3334 4.10333C12.8778 4.10289 12.441 3.92171 12.1188 3.59956C11.7967 3.2774 11.6155 2.84059 11.6151 2.385V0H3.93671C3.64215 -2.03383e-08 3.35048 0.0580281 3.07835 0.170776C2.80622 0.283525 2.55897 0.448781 2.35073 0.657104C2.14248 0.865428 1.97731 1.11274 1.86466 1.38491C1.75202 1.65708 1.6941 1.94878 1.69421 2.24334V15.7608C1.6941 16.0554 1.75202 16.3471 1.86466 16.6193C1.97731 16.8914 2.14248 17.1387 2.35073 17.3471C2.55897 17.5554 2.80622 17.7206 3.07835 17.8334C3.35048 17.9461 3.64215 18.0042 3.93671 18.0042H13.1534C13.7483 18.0042 14.319 17.7678 14.7397 17.3471C15.1604 16.9264 15.3967 16.3558 15.3967 15.7608V4.10417L13.3334 4.10333Z"
					:fill="color" />
				<path
					d="M15.3966 4.10333H13.3333C12.8777 4.10289 12.4409 3.92171 12.1188 3.59956C11.7966 3.2774 11.6154 2.84059 11.615 2.385V0L15.3966 4.10333Z"
					fill="#4F89D5" />
				<path
					d="M17.0225 14.2167H6.60248C5.86334 14.2167 5.26416 14.8159 5.26416 15.555V18.6617C5.26416 19.4008 5.86334 20 6.60248 20H17.0225C17.7616 20 18.3608 19.4008 18.3608 18.6617V15.555C18.3608 14.8159 17.7616 14.2167 17.0225 14.2167Z"
					fill="#4F89D5" />
				<path d="M8.66337 17.7809V18.3876H8.03589V17.7809H8.66337Z" fill="#F3F3F6" />
				<path d="M10.7775 15.8817V16.3634H10.0976V18.3876H9.48755V16.3634H8.81421V15.8817H10.7775Z"
					  fill="#F3F3F6" />
				<path d="M11.6408 15.8817V18.3876H11.0342V15.8817H11.6408Z" fill="#F3F3F6" />
				<path
					d="M13.6943 15.8817V16.3634H12.6667V16.9125H13.4609V17.3734H12.6667V18.3876H12.0609V15.8817H13.6943Z"
					fill="#F3F3F6" />
				<path
					d="M15.6383 15.8817V16.3634H14.6108V16.9125H15.405V17.3734H14.6108V18.3876H14.005V15.8817H15.6383Z"
					fill="#F3F3F6" />
				<path
					d="M10.3867 12.2008H6.70498C6.34464 12.2004 5.9992 12.057 5.74441 11.8022C5.48961 11.5474 5.34627 11.202 5.34583 10.8416V7.16081C5.34627 6.80047 5.48961 6.45501 5.74441 6.20022C5.9992 5.94542 6.34464 5.80208 6.70498 5.80164H10.3867C10.7468 5.8023 11.0919 5.94576 11.3464 6.20056C11.6009 6.45536 11.7439 6.80069 11.7442 7.16081V10.8416C11.7439 11.2018 11.6009 11.5471 11.3464 11.8019C11.0919 12.0567 10.7468 12.2001 10.3867 12.2008ZM6.70498 6.40247C6.50392 6.40269 6.31117 6.48266 6.16901 6.62483C6.02684 6.76699 5.94688 6.95975 5.94666 7.16081V10.8416C5.94688 11.0427 6.02684 11.2354 6.16901 11.3776C6.31117 11.5198 6.50392 11.5997 6.70498 11.6H10.3867C10.5876 11.5995 10.7801 11.5195 10.9221 11.3773C11.0641 11.2352 11.1439 11.0425 11.1441 10.8416V7.16081C11.1439 6.9599 11.0641 6.76727 10.9221 6.62512C10.7801 6.48298 10.5876 6.40291 10.3867 6.40247H6.70498Z"
					fill="#4F89D5" />
				<path
					d="M11.4442 10.1416V10.8416C11.4442 11.1222 11.3328 11.3912 11.1345 11.5897C10.9362 11.7881 10.6673 11.8997 10.3867 11.9H6.70506C6.42437 11.9 6.15518 11.7885 5.95671 11.59C5.75823 11.3915 5.64673 11.1223 5.64673 10.8416V9.66663C6.2359 9.53996 7.13341 9.49996 8.22341 9.93496L8.89756 9.29163L9.35756 10.4583C9.35756 10.4583 9.4809 10.0291 9.87923 10.09C10.2776 10.1508 10.9226 10.3666 11.1984 10.1825C11.2727 10.1396 11.36 10.1251 11.4442 10.1416Z"
					fill="#4F89D5" />
				<path
					d="M10.1559 7.91245C10.3819 7.91245 10.565 7.72926 10.565 7.50329C10.565 7.27731 10.3819 7.09412 10.1559 7.09412C9.92991 7.09412 9.7467 7.27731 9.7467 7.50329C9.7467 7.72926 9.92991 7.91245 10.1559 7.91245Z"
					fill="#4F89D5" />
			</g>
			<defs>
				<clipPath id="clip0_12_430">
					<rect width="20" height="20" fill="white" transform="translate(0.0275879)" />
				</clipPath>
			</defs>
		</svg>

	</div>
</template>

<style scoped>

</style>